export interface IRiskEditUnitChange {
    canEdit: boolean;
    canRemove: boolean;
}

export class RiskEditUnitChange implements IRiskEditUnitChange {
    canEdit: boolean;
    canRemove: boolean;
    
    constructor();
    constructor(obj: IRiskEditUnitChange);
    constructor(obj?: any) {
        this.canEdit = obj && obj.canEdit || false;
        this.canRemove = obj && obj.canRemove || false;
    }
}